import { render, staticRenderFns } from "./FutuFee.vue?vue&type=template&id=141967aa&scoped=true"
import script from "./FutuFee.vue?vue&type=script&lang=js"
export * from "./FutuFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141967aa",
  null
  
)

export default component.exports